import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/desarrollo-web/tu-sucursal-online/TuSucursalOnlineClient.tsx");
